import React from "react";
import {useSetting} from "../../contexts/setting";
import {KED_PRODUCTS_SET} from "data/products/index";

const DEFAULT_ITEMS = [
  {combination: "CMD+Shift+1", description: "highlight with white"},
  {combination: "CMD+Shift+2", description: "highlight with brand color"},
  {combination: "CMD+Shift+0", description: "remove all highlights"},
];

export const HighlightShortcuts = ({items, additionalItems = []}) => {
  const {product} = useSetting();
  const isKedProduct = KED_PRODUCTS_SET.has(product?.value);
  const resolvedItems =
    items ||
    (isKedProduct
      ? DEFAULT_ITEMS.filter((item) => item.combination !== "CMD+Shift+2")
      : DEFAULT_ITEMS);

  return (
    <div className="shortcuts">
      <div>Select the text area, then:</div>
      <div className="shortcuts-directions">
        {[...resolvedItems, ...additionalItems].map((item) => (
          <span key={`${item.combination}:${item.description}`} className="shortcut-item">
            <span className="combination">{item.combination}</span>
            {` to ${item.description}`}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HighlightShortcuts;
